<template>
    <section class="rolling-content">
        
            <div class="link-box">
                <button
                    v-if="logined"
                    class="popup-modal-open"
                    data-toggle="modal"
                    data-target="#popup-modal"
                >
                    신청하기
                </button>
                <button
                    v-else
                    class="popup-modal-open false"
                    data-toggle="modal"
                    data-target="#popup-modal"
                >
                    신청하기
                </button>
            </div>
            <div class="rolling-box">
                <!-- <div class="num-box num-box1">
          <animated-number :value="value" :formatValue="formatToPrice" :duration="3000" />
          <div>
            <strong>사례수</strong>
            <span>/건</span>
          </div>
        </div>-->

                <!-- <div class="num-box num-box2">
                    <animated-number
                        :value="value2"
                        :formatValue="formatToPrice2"
                        :duration="3000"
                    />
                    <div>
                        <strong>조회수</strong>
                        <span>/회</span>
                    </div>
                </div>

                <div class="num-box num-box3">
                    <animated-number
                        :value="value3"
                        :formatValue="formatToPrice3"
                        :duration="3000"
                    />
                    <div>
                        <strong>방문수</strong>
                        <span>/회</span>
                    </div>
                </div> -->
            </div>
       
    </section>
</template>

<script>
import AnimatedNumber from "animated-number-vue";
import axios from "axios";

export default {
    data() {
        return {
            // value: 0,
            value2: 0,
            value3: 0
        };
    },
    props: ["logined"],
    components: {
        AnimatedNumber
    },

    mounted() {
        this.plusList();
    },
    methods: {
        async plusList() {
            try {
                const res = await axios({
                    method: "GET",
                    url: `/api/hit_count/index`
                });
                // console.log(res);
                // this.value = res.data.leading_case;
                this.value2 = res.data.hit;
                this.value3 = res.data.visit;
            } catch {
            } finally {
            }
        },
        // formatToPrice(value) {
        //     return ` ${value
        //         .toFixed(0)
        //         .replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,")}`;
        // },
        formatToPrice2(value2) {
            return ` ${value2
                .toFixed(0)
                .replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,")}`;
        },
        formatToPrice3(value3) {
            return ` ${value3
                .toFixed(0)
                .replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,")}`;
        }
    }
};
</script>

<style scoped>
.rolling-content {
    /* width: 100%; */

    z-index: 200;
}
.rolling-content .container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    flex-wrap: wrap;
}
.rolling-content .rolling-box {
    display: flex;
    align-items: center;
    justify-content: space-around;
    width: 100%;
    position: absolute;
    left: 50%;
    bottom: 30px;
    transform: translateX(-50%);
    max-width: 1100px;
    padding: 0 10px;
    box-sizing: border-box;
}
.rolling-content .num-box > span {
    font-size: 2rem;
    font-weight: bold;
    color: #fff;
}
.rolling-content .num-box > div {
    text-align: center;
    font-size: 13px;
    font-weight: bold;
}
.rolling-content .num-box > div strong {
    color: #fff;
}
.rolling-content .num-box > div span {
    color: rgba(255, 255, 255, 0.8);
}
.rolling-content .num-box1 > span {
    color: #fb6037;
}
.rolling-content .link-box {
    width: 300px;
    height: 55px;
    line-height: 55px;
    text-align: center;
    background: #207bf9;
    border-radius: 55px;
    margin: 20px auto 40px;
    /* background-image: url("/img/frontend/arrow.png"); */
    background-position: 90% center;
    background-repeat: no-repeat;
}
.rolling-content .link-box button {
    display: block;
    width: 100%;
    height: 100%;
    line-height: inherit;
    text-align: inherit;
    color: #fff;
    font-size: 22px;
    font-weight: bold;
}
.rolling-content .link-box button:hover {
    text-decoration: none;
}

@media screen and (max-width: 767px) {
    /* .rolling-content .rolling-box{width: 100%;} */
}

@media screen and (max-width: 992px) {
    .rolling-content .link-box {
        position: fixed;
        z-index: 500;
        left: 50%;
        top: calc(65vh);
        margin: 0;
        transform: translateX(-50%);
        transition: 0.3s;
    }
    .rolling-content .link-box.active {
        top: calc(100% - 55px);
        width: 100%;
        transform: translateX(-50%);
        border-radius: 0;
    }
}
</style>
